import List from '../components/List'
import useRegion from '../hooks/useRegion'

import Head from 'next/head'
import { useRouter } from 'next/router'

const Search = () => {
  const { query } = useRouter()
  const { longName } = useRegion()

  return (
    <>
      <Head>
        <title>News 12 {longName} - Search</title>
      </Head>
      <List queryString={query.q} />
    </>
  )
}

export default Search
